module.exports = __webpack_public_path__ + "app/principal/subentity-details-3FhsyYlt.html";